export default __webpack_public_path__ + "static/gulabjamuncoconut-e2182d8cde71d5aae75a4433a20e7fff.png";